<div class="header-blog-nav">


<div class="navbar-top bg-black">
    <div class="container">
      <a href="tel:+393669001050"><img loading="lazy" src="https://busandbus.it/img/Icon-awesome-phone-alt.svg" alt="Numero di telefono" />
        +39 366.900.10.50</a>
      <a href="tel:+393669001060" class="ms-3"><img loading="lazy" src="https://busandbus.it/img/Icon-awesome-phone-alt.svg" alt="Numero di telefono" />
        +39 366.900.10.60</a>
    </div>
  </div>
  <nav class="navbar navbar-expand-lg bg-light">
    <div class="container">
      <div class="menu-responsive">
        <a class="navbar-brand" href="https://busandbus.it/"><img loading="lazy" src="https://busandbus.it/img/logo.svg" alt="Logo Bus&Bus" /></a>

        <button  type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" class="menu p-0 navbar-toggler"
          onclick="this.classList.toggle('opened');this.setAttribute('aria-expanded', this.classList.contains('opened'))" aria-label="Main Menu"
          id="buttonNavMobile">
          <svg width="50" height="50" viewBox="0 0 100 100">
            <path class="line line1"
              d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
            <path class="line line2" d="M 20,50 H 80" />
            <path class="line line3"
              d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
          </svg>
        </button>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent" style="flex-grow: unset">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
          <li class="nav-item">
            <a class="nav-link" aria-current="page" href="#chi-siamo" onclick="CloseMenuMobile()">Chi Siamo</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://busandbus.it/#servizi" onclick="CloseMenuMobile()">Servizi</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://busandbus.it/#mezzi" onclick="CloseMenuMobile()">Mezzi</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://busandbus.it/#preventivo" onclick="CloseMenuMobile()">Richiedi Preventivo</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://busandbus.it/faq.html" onclick="CloseMenuMobile()">FAQ</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://busandbus.it/#contatti" onclick="CloseMenuMobile()">Contatti</a>
          </li>
          <!-- <li class="nav-item lang-deskt">
            <a class="nav-link" id="toggle-lang" role="button" data-bs-toggle="modal" data-bs-target="#ModalLanguage">
              <img loading="lazy" src="img/ita.svg" alt="Italiano" />
            </a>
           
          </li> -->
          <!-- <div class="lang-responsive">
            <div class="d-flex flex-column">
              <a><img loading="lazy" src="img/ita.svg" alt="Italiano" /></a>
              <a href="" data-bs-toggle="modal" data-bs-target="#ModalLanguageResponsive">CARICA<br />le altre lingue</a>
            </div>
          </div> -->
        </ul>
      </div>
    </div>
  </nav>
</div>

<router-outlet #o="outlet"></router-outlet>

<footer>
    <div class="container">
      <div class="row text-center text-lg-start align-items-center">
        <div class="col-lg-3">
          <img loading="lazy" src="https://busandbus.it/img/logo-footer.svg" alt="Logo Bus&Bus" class="img-fluid img-footer" />
        </div>
        <div class="col-lg-3 my-3 my-lg-0">
          <p>
            AIRPORTAXI&PARKING SRLS <br /><br />
            P. Iva 04407700162<br />
            Via Folzoni 17/19, 24052 Azzano San Paolo (BG)
          </p>
        </div>
        <div class="col-lg-3 my-3 my-lg-0">
          <p>
            Tel. <a href="tel:+393669001050">+39 366.900.10.50</a><br />
            Tel. <a href="tel:+393669001060">+39 366.900.10.60</a>

            <br />Mail
            <a href="mailto:reservation@busandbus.it">reservation@busandbus.it</a>
          </p>
          <div class="dflex">
            <a href="https://www.instagram.com/busandbusnoleggio/"><img loading="lazy" src="https://busandbus.it/img/instagram.svg" alt="instagram" height="25"
                class="me-2" /></a>
            <a href="https://www.facebook.com/busandbusnoleggio"><img loading="lazy" src="https://busandbus.it/img/facebook.svg" alt="facebook" height="23" /></a>
          </div>
        </div>
        <div class="col-lg-3 text-lg-end">
          <p>
            <a href="https://busandbus.it/privacy.html"> Privacy & Cookie Policy</a><br />
            <a href="https://busandbus.it/condizioni-noleggio.pdf" target="_blank">
              Condizioni generali</a>
            <br />
            <br />
            Powered by <a href="https://www.itd-italia.com/">ITD</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
